import { render } from "./QuestDetailed.vue?vue&type=template&id=6bbe77a0&scoped=true"
import script from "./QuestDetailed.vue?vue&type=script&lang=js"
export * from "./QuestDetailed.vue?vue&type=script&lang=js"

import "./QuestDetailed.vue?vue&type=style&index=0&id=6bbe77a0&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bbe77a0"]])

export default __exports__